import SignupSuccess from "Assets/png/signupSuccess.png";
import { toasterState } from "Components/common/toaster";
import { action, observable } from "mobx";
import React, { useEffect, useState } from "react";
import userDetail, { userObj } from "Stores/userDetail";
import makeApi, { URLS } from "Utils/apiURL";
import { loginValidate } from "Utils/commonAPI";
import SequenceUtils from "Utils/SequenceUtils";
import ResendButton from "./Signup/ResendButton";

class EmailVerificationLoggedInState {
  @observable showPopup = false;

  @action
  setShowPopup = val => {
    this.showPopup = val;
  };
}

const emailVerificationLoggedInState = new EmailVerificationLoggedInState();

const EmailVerificationLoggedIn = () => {
  const [noOfClicks, setNoOfClicks] = useState(0);
  const [loader, setLoader] = useState(false);

  const resendEmailToken = async () => {
    if (noOfClicks <= 3) {
      setNoOfClicks(noOfClicks => noOfClicks + 1);
      setLoader(true);
      if (userDetail?.userInfo?.email) {
        const config = {
          url: `${URLS.signupVerification}/${userDetail?.userInfo?.email}`,
          method: "GET"
        };
        await makeApi(config);
      }
      await setLoader(false);
    }
  };

  const handleResendBtnClick = async () => {
    resendEmailToken();
  };

  const resendBtnObj = {
    className: "editSeqOkBtn",
    handleClick: handleResendBtnClick,
    isLoggedIn: noOfClicks === 0,
    noOfClicks: noOfClicks,
    setNoOfClicks: setNoOfClicks,
    loader: loader
  };

  const loginCheck = async () => {
    await loginValidate();
  };

  const handleLogout = async () => {
    try {
      const config = {
        url: URLS.logout,
        method: "POST"
      };
      let res = await makeApi(config);
      if (res) {
        userDetail.setUserInfo(userObj);
        SequenceUtils.removeActiveSequenceList();
        document.cookie = "li=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        window.location.href = "/login";
      } else {
        toasterState.setToastMsg(
          "Sorry, there was an issue while logging out of your account. Please try again later.",
          "failure"
        );
        console.error("Salesgear Logout Failed", res);
      }
    } catch (err) {
      console.error("Salesgear Logout Failed", err);
    }
  };

  useEffect(() => {
    if (emailVerificationLoggedInState.showPopup) {
      loginCheck();
    }
  }, []);

  return (
    emailVerificationLoggedInState.showPopup && (
      <>
        <div className="emailVerificationLoggedInWrapper">
          <div className="card animated customzoomIn">
            <div className="cardBody">
              <div className="fileUploadImg">
                <img src={SignupSuccess} alt="File Exceed" />
              </div>
              <div className="textWrapper">
                <p className="message" style={{ marginBottom: "20px" }}>
                  Check your inbox and verify your email address{" "}
                  <a
                    className="emailLink"
                    href={`mailTo:${userDetail?.userInfo?.email}`}
                  >{`${userDetail?.userInfo?.email}`}</a>{" "}
                  to continue using SalesIntel. If you haven't received the
                  email yet, click Resend.
                </p>
                <p className="message">
                  In case of any difficulties, please contact{" "}
                  <a className="emailLink" href={`mailto:support@salesgear.io`}>
                    support@salesgear.io
                  </a>
                  .
                </p>
              </div>
              <ResendButton {...resendBtnObj} />
              <div className="logoutButton" onClick={handleLogout}>
                Sign out
              </div>
            </div>
          </div>
        </div>
        <div className="overlayFileExceedMask" />
      </>
    )
  );
};

export { EmailVerificationLoggedIn, emailVerificationLoggedInState };
export default EmailVerificationLoggedIn;
